
<application :user="user" :header-attrs="headerAttrs">
</application>
